export const SIZES = {
  side_menu: '256px',
  margin: '84px',
}
